var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t(
          "Webheader.connector_list_" +
            _vm.entitiesType +
            "_" +
            _vm.role +
            "_" +
            _vm.type
        ),
        "show-refresh": true,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { refresh: _vm.onRefresh },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-tabs",
                {
                  attrs: {
                    value: _vm.role == 0 ? 1 : 0,
                    "nav-class": "d-none",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 0 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.receiver") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.activateSpinner
                                ? _c("spinner")
                                : _c(
                                    "div",
                                    [
                                      _vm.mqseriesCredentialFields.length
                                        ? _c("b-table", {
                                            staticClass: "mt-3 table-striped",
                                            attrs: {
                                              hover: "",
                                              relative: "",
                                              responsive: "",
                                              items: _vm.mqseriesCredentialList,
                                              fields:
                                                _vm.mqseriesCredentialFields,
                                              selectable: "",
                                              "select-mode": "single",
                                            },
                                            on: {
                                              "row-selected":
                                                _vm.seeMQSeriesCredentialDetails,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(Active)",
                                                  fn: function (data) {
                                                    return [
                                                      _vm._v(
                                                        "\n                           " +
                                                          _vm._s(
                                                            data.value === "1"
                                                              ? _vm.$t(
                                                                  "common.routing.yes"
                                                                )
                                                              : _vm.$t(
                                                                  "common.routing.no"
                                                                )
                                                          ) +
                                                          "\n                         "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              656112213
                                            ),
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "noResult" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.no_result"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 1 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.responder") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.activateSpinner
                                ? _c("spinner")
                                : _c(
                                    "div",
                                    [
                                      _vm.mqseriesFields.length
                                        ? _c("b-table", {
                                            staticClass:
                                              "mt-3 table-striped table-hover",
                                            attrs: {
                                              hover: "",
                                              relative: "",
                                              responsive: "",
                                              items: _vm.mqseriesConfigList,
                                              fields: _vm.mqseriesFields,
                                              selectable: "",
                                              "select-mode": "single",
                                            },
                                            on: {
                                              "row-selected":
                                                _vm.seeMQSeriesDetails,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(Active)",
                                                  fn: function (data) {
                                                    return [
                                                      _vm._v(
                                                        "\n                           " +
                                                          _vm._s(
                                                            data.value === "1"
                                                              ? _vm.$t(
                                                                  "common.routing.yes"
                                                                )
                                                              : _vm.$t(
                                                                  "common.routing.no"
                                                                )
                                                          ) +
                                                          "\n                         "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              656112213
                                            ),
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "noResult" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.no_result"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }